import { DatePicker } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';

/**
 * DatePicker glued to a plain `YYYY-MM-DD` string so form state is JSON-safe
 * and matches the shape `@velora/contracts` expects. `variant="dob"` opens on
 * the year cell and disables today and future — a birthdate is never today.
 */
export type DateFieldVariant = 'dob' | 'default';

interface Props {
  value?: string;
  onChange?: (value: string | undefined) => void;
  onBlur?: () => void;
  variant?: DateFieldVariant;
  disabled?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  status?: 'error' | 'warning';
  id?: string;
}

export function DateField({ value, onChange, variant = 'default', placeholder, ...rest }: Props) {
  const parsed = value ? dayjs(value, 'YYYY-MM-DD', true) : null;
  const dayjsValue = parsed && parsed.isValid() ? parsed : null;
  const isDob = variant === 'dob';

  return (
    <DatePicker
      value={dayjsValue}
      onChange={(d) => onChange?.(d ? d.format('YYYY-MM-DD') : undefined)}
      format="DD MMM YYYY"
      picker="date"
      defaultPickerValue={isDob && !dayjsValue ? dayjs().subtract(10, 'year') : undefined}
      disabledDate={isDob ? (d: Dayjs) => d.isAfter(dayjs().endOf('day')) : undefined}
      placeholder={placeholder ?? (isDob ? 'DD MMM YYYY' : 'Pick a date')}
      allowClear
      style={{ width: '100%' }}
      {...rest}
    />
  );
}
